module.exports = __webpack_public_path__ + "img/bg-3-4.36f9fbbd.png";